<template>
  <div id="scroll" class="article-list bg-white">
    <navbar />

    <div class="lower-mv" :style="lowermv">
      <h2>{{ $t('blog_list') }}</h2>
    </div>
    <section class="lower-page wrapper">
      <div class="lower-category">
        <span>{{ $t('category') }}</span>
        <ul>
          <li v-for="(category) in blogCategories" :key="category">
            <a @click="changeCategory(category)" :class="activeCategory(category)">{{ $t(category == null ? 'all' : category) }}</a>
          </li>
        </ul>
      </div>
      <div class="article_contents_list">
        <ul v-if="articles">
          <li v-for="(article, index) in displayedArticle" :key="index">
            <a :href="$router.resolve({ name: 'Client Blog Detail', params: { lang: activeLanguage, id: article.id } }).href" target="_top">
              <div class="thumb-box" v-if="article.blog_images">
                <img :src="article.blog_images.url">
              </div>
              <div class="thumb-box" v-else>
                <img src="N/A">
              </div>
              <div class="blog_txt">
                <h3>{{article.blog_articles_details[0].title}}</h3>
                <p>{{moment(article.created_at).format('YYYY/MM/DD')}}</p>
              </div>
              <span class="blog_cat">{{$t(article.category)}}</span>
            </a>
          </li>
        </ul>
      </div>
      <div v-if="articles">
        <div v-show="articleList.length > parPage">
        <paginate
          v-model="currentPage"
          :page-count="getPageCount"
          :page-range="3"
          :click-handler="changePage"
          :active-class="'pager-current'"
          :prev-link-class="'lower-pager-fast'"
          :next-link-class="'lower-pager-last'"
          :prev-text="''"
          :next-text="''"
          :container-class="'lower-pager'"
          :no-li-surround="true"
          href="#scroll" v-smooth-scroll>
        </paginate>
        </div>
      </div>
    </section>
    <footerClient />
  </div>
</template>

<script>
import navbar from '@/components/client/navbar'
import footerClient from '@/components/client/footerClient'
import { mapState, mapActions } from 'vuex'
import paginate from 'vuejs-paginate'
import { blogCategories } from '../../../assets/data/values'

export default {
  data () {
    return {
      lowermv: {
        background: `url(${require('@/assets/img/client/lower_mvbg.jpg')}) center / cover`
      },
      filter: {
        category: null,
        language: this.$route.params.lang
      },
      activeLanguage: this.$route.params.lang,
      parPage: 12,
      currentPage: 1,
      blogCategories: [null].concat(blogCategories)
    }
  },
  created () {
    this.getArticles(this.$route.params.lang)
  },
  computed: {
    ...mapState('blogClient', ['articles']),
    articleList: function () {
      return this.articles
        .filter(this.filterByCategory)
    },
    displayedArticle: function () {
      let current = this.currentPage * this.parPage
      if (this.articleList.length < 12) {
        current = 12
      }
      const start = current - this.parPage
      return this.articleList.slice(start, current)
    },
    getPageCount: function () {
      return Math.ceil(this.articleList.length / this.parPage)
    }
  },
  methods: {
    ...mapActions('blogClient', ['getArticles']),
    dateFormat: function (createdDate) {
      return createdDate.substring(0, 10)
    },
    filterByCategory: function (article) {
      if (this.filter.category === null) {
        return true
      }
      return (article.category === this.filter.category)
    },
    changeCategory: function (category) {
      if (this.filter.category === category) {
        return
      }

      this.filter.category = category
      this.changePage(1)
    },
    changePage: function (pageNum) {
      this.currentPage = Number(pageNum)
    },
    activeCategory: function (value) {
      if (this.filter.category === value) {
        return 'category-current'
      }
    }
  },
  components: {
    navbar,
    footerClient,
    paginate
  }
}
</script>
